"use strict";
exports.__esModule = true;
exports.CHANNEX_INTEGRATIONS_LIST = exports.CHANNEX_CODES = exports.CHANNEX_COUNTRIES_VALUES = exports.CHANNEX_COUNTRIES = exports.CHANNEX_TIMEZONES = exports.CHANNEX_CURRENCIES_VALUES = exports.CHANNEX_CURRENCIES = exports.CHANNEX_EVENTS = exports.CHANNEX_CACHE_KEYS = exports.CHANNEX_API_URL = exports.CHANNEX_ACCESS_TOKEN_CACHE_KEY = exports.CHANNEX_DEV_MODE = void 0;
exports.CHANNEX_DEV_MODE = true;
exports.CHANNEX_ACCESS_TOKEN_CACHE_KEY = 'CHANNEX_ACCESS_TOKEN';
exports.CHANNEX_API_URL = {
    STAGE: 'https://staging.channex.io/api/v1',
    PROD: 'https://app.channex.io/api/v1'
};
exports.CHANNEX_CACHE_KEYS = {
    AUTH: 'AUTH',
    GROUPS: 'GROUPS',
    PROPERTIES: 'PROPERTIES',
    ROOM_TYPES: 'ROOM_TYPES'
};
exports.CHANNEX_EVENTS = {
    AUTH: {
        SIGN_IN: 'AUTH.SIGN_IN',
        REQUEST_RESTORE_PASSWORD: 'REQUEST_RESTORE_PASSWORD',
        RESTORE_PASSWORD: 'RESTORE_PASSWORD'
    },
    PROPERTIES: {
        PROPERTIES: 'PROPERTIES.PROPERTIES',
        HEALTH: 'PROPERTIES.HEALTH',
        OPTIONS: 'PROPERTIES.OPTIONS',
        CREATE: 'PROPERTIES.CREATE',
        GET_BY_ID: 'PROPERTIES.GET_BY_ID',
        HEALTH_BY_ID: 'PROPERTIES.HEALTH_BY_ID',
        UPDATE: 'PROPERTIES.UPDATE'
    },
    PROPERTY_USERS: {
        PROPERTY_USERS: 'PROPERTY_USERS.PROPERTY_USERS',
        INVITE_USERS_TO_PROPERTY: 'PROPERTY_USERS.INVITE_USERS_TO_PROPERTY',
        GET_PROPERTY_USERS_BY_ID: 'PROPERTY_USERS.GET_PROPERTY_USERS_BY_ID',
        UPDATE_PROPERTY_USER: 'PROPERTY_USERS.UPDATE_PROPERTY_USER',
        WITHDRAW_USER_ACCESS: 'PROPERTY_USERS.WITHDRAW_USER_ACCESS'
    },
    GROUPS: {
        GROUPS: 'GROUPS.GROUPS',
        GROUP_BY_ID: 'GROUPS.GROUP_BY_ID',
        CREATE: 'GROUPS.CREATE',
        UPDATE: 'GROUPS.UPDATE',
        DELETE: 'GROUPS.DELETE',
        ASSOCIATE_PROPERTY_WITH_GROUP: 'GROUPS.ASSOCIATE_PROPERTY_WITH_GROUP',
        DELETE_PROPERTY_FROM_GROUP: 'GROUPS.DELETE_PROPERTY_FROM_GROUP'
    },
    ROOM_TYPES: {
        CREATE: 'ROOM_TYPES.CREATE',
        UPDATE: 'ROOM_TYPES.UPDATE'
    }
};
var CHANNEX_CURRENCIES;
(function (CHANNEX_CURRENCIES) {
    CHANNEX_CURRENCIES["AFN"] = "AFN";
    CHANNEX_CURRENCIES["EUR"] = "EUR";
    CHANNEX_CURRENCIES["ALL"] = "ALL";
    CHANNEX_CURRENCIES["DZD"] = "DZD";
    CHANNEX_CURRENCIES["USD"] = "USD";
    CHANNEX_CURRENCIES["AOA"] = "AOA";
    CHANNEX_CURRENCIES["XCD"] = "XCD";
    CHANNEX_CURRENCIES["ARS"] = "ARS";
    CHANNEX_CURRENCIES["AMD"] = "AMD";
    CHANNEX_CURRENCIES["AWG"] = "AWG";
    CHANNEX_CURRENCIES["AUD"] = "AUD";
    CHANNEX_CURRENCIES["AZN"] = "AZN";
    CHANNEX_CURRENCIES["BSD"] = "BSD";
    CHANNEX_CURRENCIES["BHD"] = "BHD";
    CHANNEX_CURRENCIES["BDT"] = "BDT";
    CHANNEX_CURRENCIES["BBD"] = "BBD";
    CHANNEX_CURRENCIES["BYN"] = "BYN";
    CHANNEX_CURRENCIES["BZD"] = "BZD";
    CHANNEX_CURRENCIES["XOF"] = "XOF";
    CHANNEX_CURRENCIES["BMD"] = "BMD";
    CHANNEX_CURRENCIES["INR"] = "INR";
    CHANNEX_CURRENCIES["BTN"] = "BTN";
    CHANNEX_CURRENCIES["BOB"] = "BOB";
    CHANNEX_CURRENCIES["BOV"] = "BOV";
    CHANNEX_CURRENCIES["BAM"] = "BAM";
    CHANNEX_CURRENCIES["BWP"] = "BWP";
    CHANNEX_CURRENCIES["NOK"] = "NOK";
    CHANNEX_CURRENCIES["BRL"] = "BRL";
    CHANNEX_CURRENCIES["BND"] = "BND";
    CHANNEX_CURRENCIES["BGN"] = "BGN";
    CHANNEX_CURRENCIES["BIF"] = "BIF";
    CHANNEX_CURRENCIES["CVE"] = "CVE";
    CHANNEX_CURRENCIES["KHR"] = "KHR";
    CHANNEX_CURRENCIES["XAF"] = "XAF";
    CHANNEX_CURRENCIES["CAD"] = "CAD";
    CHANNEX_CURRENCIES["KYD"] = "KYD";
    CHANNEX_CURRENCIES["CLP"] = "CLP";
    CHANNEX_CURRENCIES["CLF"] = "CLF";
    CHANNEX_CURRENCIES["CNY"] = "CNY";
    CHANNEX_CURRENCIES["COP"] = "COP";
    CHANNEX_CURRENCIES["COU"] = "COU";
    CHANNEX_CURRENCIES["KMF"] = "KMF";
    CHANNEX_CURRENCIES["CDF"] = "CDF";
    CHANNEX_CURRENCIES["NZD"] = "NZD";
    CHANNEX_CURRENCIES["CRC"] = "CRC";
    CHANNEX_CURRENCIES["HRK"] = "HRK";
    CHANNEX_CURRENCIES["CUP"] = "CUP";
    CHANNEX_CURRENCIES["CUC"] = "CUC";
    CHANNEX_CURRENCIES["ANG"] = "ANG";
    CHANNEX_CURRENCIES["CZK"] = "CZK";
    CHANNEX_CURRENCIES["DKK"] = "DKK";
    CHANNEX_CURRENCIES["DJF"] = "DJF";
    CHANNEX_CURRENCIES["DOP"] = "DOP";
    CHANNEX_CURRENCIES["EGP"] = "EGP";
    CHANNEX_CURRENCIES["SVC"] = "SVC";
    CHANNEX_CURRENCIES["ERN"] = "ERN";
    CHANNEX_CURRENCIES["SZL"] = "SZL";
    CHANNEX_CURRENCIES["ETB"] = "ETB";
    CHANNEX_CURRENCIES["FKP"] = "FKP";
    CHANNEX_CURRENCIES["FJD"] = "FJD";
    CHANNEX_CURRENCIES["XPF"] = "XPF";
    CHANNEX_CURRENCIES["GMD"] = "GMD";
    CHANNEX_CURRENCIES["GEL"] = "GEL";
    CHANNEX_CURRENCIES["GHS"] = "GHS";
    CHANNEX_CURRENCIES["GIP"] = "GIP";
    CHANNEX_CURRENCIES["GTQ"] = "GTQ";
    CHANNEX_CURRENCIES["GBP"] = "GBP";
    CHANNEX_CURRENCIES["GNF"] = "GNF";
    CHANNEX_CURRENCIES["GYD"] = "GYD";
    CHANNEX_CURRENCIES["HTG"] = "HTG";
    CHANNEX_CURRENCIES["HNL"] = "HNL";
    CHANNEX_CURRENCIES["HKD"] = "HKD";
    CHANNEX_CURRENCIES["HUF"] = "HUF";
    CHANNEX_CURRENCIES["ISK"] = "ISK";
    CHANNEX_CURRENCIES["IDR"] = "IDR";
    CHANNEX_CURRENCIES["XDR"] = "XDR";
    CHANNEX_CURRENCIES["IRR"] = "IRR";
    CHANNEX_CURRENCIES["IQD"] = "IQD";
    CHANNEX_CURRENCIES["ILS"] = "ILS";
    CHANNEX_CURRENCIES["JMD"] = "JMD";
    CHANNEX_CURRENCIES["JPY"] = "JPY";
    CHANNEX_CURRENCIES["JOD"] = "JOD";
    CHANNEX_CURRENCIES["KZT"] = "KZT";
    CHANNEX_CURRENCIES["KES"] = "KES";
    CHANNEX_CURRENCIES["KPW"] = "KPW";
    CHANNEX_CURRENCIES["KRW"] = "KRW";
    CHANNEX_CURRENCIES["KWD"] = "KWD";
    CHANNEX_CURRENCIES["KGS"] = "KGS";
    CHANNEX_CURRENCIES["LAK"] = "LAK";
    CHANNEX_CURRENCIES["LBP"] = "LBP";
    CHANNEX_CURRENCIES["LSL"] = "LSL";
    CHANNEX_CURRENCIES["ZAR"] = "ZAR";
    CHANNEX_CURRENCIES["LRD"] = "LRD";
    CHANNEX_CURRENCIES["LYD"] = "LYD";
    CHANNEX_CURRENCIES["CHF"] = "CHF";
    CHANNEX_CURRENCIES["MOP"] = "MOP";
    CHANNEX_CURRENCIES["MKD"] = "MKD";
    CHANNEX_CURRENCIES["MGA"] = "MGA";
    CHANNEX_CURRENCIES["MWK"] = "MWK";
    CHANNEX_CURRENCIES["MYR"] = "MYR";
    CHANNEX_CURRENCIES["MVR"] = "MVR";
    CHANNEX_CURRENCIES["MRU"] = "MRU";
    CHANNEX_CURRENCIES["MUR"] = "MUR";
    CHANNEX_CURRENCIES["XUA"] = "XUA";
    CHANNEX_CURRENCIES["MXN"] = "MXN";
    CHANNEX_CURRENCIES["MXV"] = "MXV";
    CHANNEX_CURRENCIES["MDL"] = "MDL";
    CHANNEX_CURRENCIES["MNT"] = "MNT";
    CHANNEX_CURRENCIES["MAD"] = "MAD";
    CHANNEX_CURRENCIES["MZN"] = "MZN";
    CHANNEX_CURRENCIES["MMK"] = "MMK";
    CHANNEX_CURRENCIES["NAD"] = "NAD";
    CHANNEX_CURRENCIES["NPR"] = "NPR";
    CHANNEX_CURRENCIES["NIO"] = "NIO";
    CHANNEX_CURRENCIES["NGN"] = "NGN";
    CHANNEX_CURRENCIES["OMR"] = "OMR";
    CHANNEX_CURRENCIES["PKR"] = "PKR";
    CHANNEX_CURRENCIES["PAB"] = "PAB";
    CHANNEX_CURRENCIES["PGK"] = "PGK";
    CHANNEX_CURRENCIES["PYG"] = "PYG";
    CHANNEX_CURRENCIES["PEN"] = "PEN";
    CHANNEX_CURRENCIES["PHP"] = "PHP";
    CHANNEX_CURRENCIES["PLN"] = "PLN";
    CHANNEX_CURRENCIES["QAR"] = "QAR";
    CHANNEX_CURRENCIES["RON"] = "RON";
    CHANNEX_CURRENCIES["RUB"] = "RUB";
    CHANNEX_CURRENCIES["RWF"] = "RWF";
    CHANNEX_CURRENCIES["SHP"] = "SHP";
    CHANNEX_CURRENCIES["WST"] = "WST";
    CHANNEX_CURRENCIES["STN"] = "STN";
    CHANNEX_CURRENCIES["SAR"] = "SAR";
    CHANNEX_CURRENCIES["RSD"] = "RSD";
    CHANNEX_CURRENCIES["SCR"] = "SCR";
    CHANNEX_CURRENCIES["SLL"] = "SLL";
    CHANNEX_CURRENCIES["SGD"] = "SGD";
    CHANNEX_CURRENCIES["XSU"] = "XSU";
    CHANNEX_CURRENCIES["SBD"] = "SBD";
    CHANNEX_CURRENCIES["SOS"] = "SOS";
    CHANNEX_CURRENCIES["SSP"] = "SSP";
    CHANNEX_CURRENCIES["LKR"] = "LKR";
    CHANNEX_CURRENCIES["SDG"] = "SDG";
    CHANNEX_CURRENCIES["SRD"] = "SRD";
    CHANNEX_CURRENCIES["SEK"] = "SEK";
    CHANNEX_CURRENCIES["CHE"] = "CHE";
    CHANNEX_CURRENCIES["CHW"] = "CHW";
    CHANNEX_CURRENCIES["SYP"] = "SYP";
    CHANNEX_CURRENCIES["TWD"] = "TWD";
    CHANNEX_CURRENCIES["TJS"] = "TJS";
    CHANNEX_CURRENCIES["TZS"] = "TZS";
    CHANNEX_CURRENCIES["THB"] = "THB";
    CHANNEX_CURRENCIES["TOP"] = "TOP";
    CHANNEX_CURRENCIES["TTD"] = "TTD";
    CHANNEX_CURRENCIES["TND"] = "TND";
    CHANNEX_CURRENCIES["TRY"] = "TRY";
    CHANNEX_CURRENCIES["TMT"] = "TMT";
    CHANNEX_CURRENCIES["UGX"] = "UGX";
    CHANNEX_CURRENCIES["UAH"] = "UAH";
    CHANNEX_CURRENCIES["AED"] = "AED";
    CHANNEX_CURRENCIES["USN"] = "USN";
    CHANNEX_CURRENCIES["UYU"] = "UYU";
    CHANNEX_CURRENCIES["UYI"] = "UYI";
    CHANNEX_CURRENCIES["UYW"] = "UYW";
    CHANNEX_CURRENCIES["UZS"] = "UZS";
    CHANNEX_CURRENCIES["VUV"] = "VUV";
    CHANNEX_CURRENCIES["VES"] = "VES";
    CHANNEX_CURRENCIES["VND"] = "VND";
    CHANNEX_CURRENCIES["YER"] = "YER";
    CHANNEX_CURRENCIES["ZMW"] = "ZMW";
    CHANNEX_CURRENCIES["ZWL"] = "ZWL";
    CHANNEX_CURRENCIES["XBA"] = "XBA";
    CHANNEX_CURRENCIES["XBB"] = "XBB";
    CHANNEX_CURRENCIES["XBC"] = "XBC";
    CHANNEX_CURRENCIES["XBD"] = "XBD";
    CHANNEX_CURRENCIES["XTS"] = "XTS";
    CHANNEX_CURRENCIES["XXX"] = "XXX";
    CHANNEX_CURRENCIES["XAU"] = "XAU";
    CHANNEX_CURRENCIES["XPD"] = "XPD";
    CHANNEX_CURRENCIES["XPT"] = "XPT";
    CHANNEX_CURRENCIES["XAG"] = "XAG";
})(CHANNEX_CURRENCIES = exports.CHANNEX_CURRENCIES || (exports.CHANNEX_CURRENCIES = {}));
exports.CHANNEX_CURRENCIES_VALUES = [
    'AFN',
    'EUR',
    'ALL',
    'DZD',
    'USD',
    'AOA',
    'XCD',
    'ARS',
    'AMD',
    'AWG',
    'AUD',
    'AZN',
    'BSD',
    'BHD',
    'BDT',
    'BBD',
    'BYN',
    'BZD',
    'XOF',
    'BMD',
    'INR',
    'BTN',
    'BOB',
    'BOV',
    'BAM',
    'BWP',
    'NOK',
    'BRL',
    'BND',
    'BGN',
    'BIF',
    'CVE',
    'KHR',
    'XAF',
    'CAD',
    'KYD',
    'CLP',
    'CLF',
    'CNY',
    'COP',
    'COU',
    'KMF',
    'CDF',
    'NZD',
    'CRC',
    'HRK',
    'CUP',
    'CUC',
    'ANG',
    'CZK',
    'DKK',
    'DJF',
    'DOP',
    'EGP',
    'SVC',
    'ERN',
    'SZL',
    'ETB',
    'FKP',
    'FJD',
    'XPF',
    'GMD',
    'GEL',
    'GHS',
    'GIP',
    'GTQ',
    'GBP',
    'GNF',
    'GYD',
    'HTG',
    'HNL',
    'HKD',
    'HUF',
    'ISK',
    'IDR',
    'XDR',
    'IRR',
    'IQD',
    'ILS',
    'JMD',
    'JPY',
    'JOD',
    'KZT',
    'KES',
    'KPW',
    'KRW',
    'KWD',
    'KGS',
    'LAK',
    'LBP',
    'LSL',
    'ZAR',
    'LRD',
    'LYD',
    'CHF',
    'MOP',
    'MKD',
    'MGA',
    'MWK',
    'MYR',
    'MVR',
    'MRU',
    'MUR',
    'XUA',
    'MXN',
    'MXV',
    'MDL',
    'MNT',
    'MAD',
    'MZN',
    'MMK',
    'NAD',
    'NPR',
    'NIO',
    'NGN',
    'OMR',
    'PKR',
    'PAB',
    'PGK',
    'PYG',
    'PEN',
    'PHP',
    'PLN',
    'QAR',
    'RON',
    'RUB',
    'RWF',
    'SHP',
    'WST',
    'STN',
    'SAR',
    'RSD',
    'SCR',
    'SLL',
    'SGD',
    'XSU',
    'SBD',
    'SOS',
    'SSP',
    'LKR',
    'SDG',
    'SRD',
    'SEK',
    'CHE',
    'CHW',
    'SYP',
    'TWD',
    'TJS',
    'TZS',
    'THB',
    'TOP',
    'TTD',
    'TND',
    'TRY',
    'TMT',
    'UGX',
    'UAH',
    'AED',
    'USN',
    'UYU',
    'UYI',
    'UYW',
    'UZS',
    'VUV',
    'VES',
    'VND',
    'YER',
    'ZMW',
    'ZWL',
    'XBA',
    'XBB',
    'XBC',
    'XBD',
    'XTS',
    'XXX',
    'XAU',
    'XPD',
    'XPT',
    'XAG',
];
exports.CHANNEX_TIMEZONES = [
    'America/Puerto_Rico',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
    'America/Adak',
    'America/Anguilla',
    'America/Antigua',
    'America/Araguaina',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca',
    'America/Argentina/ComodRivadavia',
    'America/Argentina/Cordoba',
    'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta',
    'America/Argentina/San_Juan',
    'America/Argentina/San_Luis',
    'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia',
    'America/Aruba',
    'America/Asuncion',
    'America/Atikokan',
    'America/Atka',
    'America/Bahia',
    'America/Barbados',
    'America/Belem',
    'America/Belize',
    'America/Blanc-Sablon',
    'America/Boa_Vista',
    'America/Bogota',
    'America/Boise',
    'America/Buenos_Aires',
    'America/Cambridge_Bay',
    'America/Campo_Grande',
    'America/Cancun',
    'America/Caracas',
    'America/Catamarca',
    'America/Cayenne',
    'America/Cayman',
    'America/Chihuahua',
    'America/Coral_Harbour',
    'America/Cordoba',
    'America/Costa_Rica',
    'America/Cuiaba',
    'America/Curacao',
    'America/Danmarkshavn',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Detroit',
    'America/Dominica',
    'America/Edmonton',
    'America/Eirunepe',
    'America/El_Salvador',
    'America/Ensenada',
    'America/Fortaleza',
    'America/Fort_Wayne',
    'America/Glace_Bay',
    'America/Godthab',
    'America/Goose_Bay',
    'America/Grand_Turk',
    'America/Grenada',
    'America/Guadeloupe',
    'America/Guatemala',
    'America/Guayaquil',
    'America/Guyana',
    'America/Halifax',
    'America/Havana',
    'America/Hermosillo',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indianapolis',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Jamaica',
    'America/Jujuy',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Knox_IN',
    'America/La_Paz',
    'America/Lima',
    'America/Louisville',
    'America/Maceio',
    'America/Managua',
    'America/Manaus',
    'America/Marigot',
    'America/Martinique',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Mendoza',
    'America/Menominee',
    'America/Merida',
    'America/Mexico_City',
    'America/Miquelon',
    'America/Moncton',
    'America/Monterrey',
    'America/Montevideo',
    'America/Montreal',
    'America/Montserrat',
    'America/Nassau',
    'America/Nipigon',
    'America/Nome',
    'America/Noronha',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Ojinaga',
    'America/Panama',
    'America/Pangnirtung',
    'America/Paramaribo',
    'America/Port-au-Prince',
    'America/Porto_Acre',
    'America/Port_of_Spain',
    'America/Porto_Velho',
    'America/Rainy_River',
    'America/Rankin_Inlet',
    'America/Recife',
    'America/Regina',
    'America/Resolute',
    'America/Rio_Branco',
    'America/Rosario',
    'America/Santa_Isabel',
    'America/Santarem',
    'America/Santiago',
    'America/Santo_Domingo',
    'America/Sao_Paulo',
    'America/Scoresbysund',
    'America/Shiprock',
    'America/St_Barthelemy',
    'America/St_Johns',
    'America/St_Kitts',
    'America/St_Lucia',
    'America/St_Thomas',
    'America/St_Vincent',
    'America/Swift_Current',
    'America/Tegucigalpa',
    'America/Thule',
    'America/Thunder_Bay',
    'America/Tijuana',
    'America/Toronto',
    'America/Tortola',
    'America/Vancouver',
    'America/Virgin',
    'America/Whitehorse',
    'America/Winnipeg',
    'America/Yakutat',
    'America/Yellowknife',
    'Europe/Amsterdam',
    'Europe/Andorra',
    'Europe/Athens',
    'Europe/Belfast',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Bratislava',
    'Europe/Brussels',
    'Europe/Bucharest',
    'Europe/Budapest',
    'Europe/Chisinau',
    'Europe/Copenhagen',
    'Europe/Dublin',
    'Europe/Gibraltar',
    'Europe/Guernsey',
    'Europe/Helsinki',
    'Europe/Isle_of_Man',
    'Europe/Istanbul',
    'Europe/Jersey',
    'Europe/Kaliningrad',
    'Europe/Kiev',
    'Europe/Lisbon',
    'Europe/Ljubljana',
    'Europe/London',
    'Europe/Luxembourg',
    'Europe/Madrid',
    'Europe/Malta',
    'Europe/Mariehamn',
    'Europe/Minsk',
    'Europe/Monaco',
    'Europe/Moscow',
    'Europe/Nicosia',
    'Europe/Oslo',
    'Europe/Paris',
    'Europe/Podgorica',
    'Europe/Prague',
    'Europe/Riga',
    'Europe/Rome',
    'Europe/Samara',
    'Europe/San_Marino',
    'Europe/Sarajevo',
    'Europe/Simferopol',
    'Europe/Skopje',
    'Europe/Sofia',
    'Europe/Stockholm',
    'Europe/Tallinn',
    'Europe/Tirane',
    'Europe/Tiraspol',
    'Europe/Uzhgorod',
    'Europe/Vaduz',
    'Europe/Vatican',
    'Europe/Vienna',
    'Europe/Vilnius',
    'Europe/Volgograd',
    'Europe/Warsaw',
    'Europe/Zagreb',
    'Europe/Zaporozhye',
    'Europe/Zurich',
    'Asia/Aden',
    'Asia/Almaty',
    'Asia/Amman',
    'Asia/Anadyr',
    'Asia/Aqtau',
    'Asia/Aqtobe',
    'Asia/Ashgabat',
    'Asia/Ashkhabad',
    'Asia/Baghdad',
    'Asia/Bahrain',
    'Asia/Baku',
    'Asia/Bangkok',
    'Asia/Beirut',
    'Asia/Bishkek',
    'Asia/Brunei',
    'Asia/Calcutta',
    'Asia/Choibalsan',
    'Asia/Chongqing',
    'Asia/Chungking',
    'Asia/Colombo',
    'Asia/Dacca',
    'Asia/Damascus',
    'Asia/Dhaka',
    'Asia/Dili',
    'Asia/Dubai',
    'Asia/Dushanbe',
    'Asia/Gaza',
    'Asia/Harbin',
    'Asia/Ho_Chi_Minh',
    'Asia/Hong_Kong',
    'Asia/Hovd',
    'Asia/Irkutsk',
    'Asia/Istanbul',
    'Asia/Jakarta',
    'Asia/Jayapura',
    'Asia/Jerusalem',
    'Asia/Kabul',
    'Asia/Kamchatka',
    'Asia/Karachi',
    'Asia/Kashgar',
    'Asia/Kathmandu',
    'Asia/Katmandu',
    'Asia/Kolkata',
    'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Asia/Kuwait',
    'Asia/Macao',
    'Asia/Macau',
    'Asia/Magadan',
    'Asia/Makassar',
    'Asia/Manila',
    'Asia/Muscat',
    'Asia/Nicosia',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Oral',
    'Asia/Phnom_Penh',
    'Asia/Pontianak',
    'Asia/Pyongyang',
    'Asia/Qatar',
    'Asia/Qyzylorda',
    'Asia/Rangoon',
    'Asia/Riyadh',
    'Asia/Saigon',
    'Asia/Sakhalin',
    'Asia/Samarkand',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Taipei',
    'Asia/Tashkent',
    'Asia/Tbilisi',
    'Asia/Tehran',
    'Asia/Tel_Aviv',
    'Asia/Thimbu',
    'Asia/Thimphu',
    'Asia/Tokyo',
    'Asia/Ujung_Pandang',
    'Asia/Ulaanbaatar',
    'Asia/Ulan_Bator',
    'Asia/Urumqi',
    'Asia/Vientiane',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Asia/Yerevan',
    'Africa/Abidjan',
    'Africa/Accra',
    'Africa/Addis_Ababa',
    'Africa/Algiers',
    'Africa/Asmara',
    'Africa/Asmera',
    'Africa/Bamako',
    'Africa/Bangui',
    'Africa/Banjul',
    'Africa/Bissau',
    'Africa/Blantyre',
    'Africa/Brazzaville',
    'Africa/Bujumbura',
    'Africa/Cairo',
    'Africa/Casablanca',
    'Africa/Ceuta',
    'Africa/Conakry',
    'Africa/Dakar',
    'Africa/Dar_es_Salaam',
    'Africa/Djibouti',
    'Africa/Douala',
    'Africa/El_Aaiun',
    'Africa/Freetown',
    'Africa/Gaborone',
    'Africa/Harare',
    'Africa/Johannesburg',
    'Africa/Kampala',
    'Africa/Khartoum',
    'Africa/Kigali',
    'Africa/Kinshasa',
    'Africa/Lagos',
    'Africa/Libreville',
    'Africa/Lome',
    'Africa/Luanda',
    'Africa/Lubumbashi',
    'Africa/Lusaka',
    'Africa/Malabo',
    'Africa/Maputo',
    'Africa/Maseru',
    'Africa/Mbabane',
    'Africa/Mogadishu',
    'Africa/Monrovia',
    'Africa/Nairobi',
    'Africa/Ndjamena',
    'Africa/Niamey',
    'Africa/Nouakchott',
    'Africa/Ouagadougou',
    'Africa/Porto-Novo',
    'Africa/Sao_Tome',
    'Africa/Timbuktu',
    'Africa/Tripoli',
    'Africa/Tunis',
    'Africa/Windhoek',
    'Australia/ACT',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Canberra',
    'Australia/Currie',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Hobart',
    'Australia/LHI',
    'Australia/Lindeman',
    'Australia/Lord_Howe',
    'Australia/Melbourne',
    'Australia/North',
    'Australia/NSW',
    'Australia/Perth',
    'Australia/Queensland',
    'Australia/South',
    'Australia/Sydney',
    'Australia/Tasmania',
    'Australia/Victoria',
    'Australia/West',
    'Australia/Yancowinna',
    'Indian/Antananarivo',
    'Indian/Chagos',
    'Indian/Christmas',
    'Indian/Cocos',
    'Indian/Comoro',
    'Indian/Kerguelen',
    'Indian/Mahe',
    'Indian/Maldives',
    'Indian/Mauritius',
    'Indian/Mayotte',
    'Indian/Reunion',
    'Atlantic/Azores',
    'Atlantic/Bermuda',
    'Atlantic/Canary',
    'Atlantic/Cape_Verde',
    'Atlantic/Faeroe',
    'Atlantic/Faroe',
    'Atlantic/Jan_Mayen',
    'Atlantic/Madeira',
    'Atlantic/Reykjavik',
    'Atlantic/South_Georgia',
    'Atlantic/Stanley',
    'Atlantic/St_Helena',
    'Pacific/Apia',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'Pacific/Easter',
    'Pacific/Efate',
    'Pacific/Enderbury',
    'Pacific/Fakaofo',
    'Pacific/Fiji',
    'Pacific/Funafuti',
    'Pacific/Galapagos',
    'Pacific/Gambier',
    'Pacific/Guadalcanal',
    'Pacific/Guam',
    'Pacific/Johnston',
    'Pacific/Kiritimati',
    'Pacific/Kosrae',
    'Pacific/Kwajalein',
    'Pacific/Majuro',
    'Pacific/Marquesas',
    'Pacific/Midway',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Norfolk',
    'Pacific/Noumea',
    'Pacific/Pago_Pago',
    'Pacific/Palau',
    'Pacific/Pitcairn',
    'Pacific/Ponape',
    'Pacific/Port_Moresby',
    'Pacific/Rarotonga',
    'Pacific/Saipan',
    'Pacific/Samoa',
    'Pacific/Tahiti',
    'Pacific/Tarawa',
    'Pacific/Tongatapu',
    'Pacific/Truk',
    'Pacific/Wake',
    'Pacific/Wallis',
    'Pacific/Yap',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Macquarie',
    'Antarctica/Mawson',
    'Antarctica/McMurdo',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/South_Pole',
    'Antarctica/Syowa',
    'Antarctica/Vostok',
    'Arctic/Longyearbyen',
    'UTC',
    'UTC-12',
    'UTC-11',
    'UTC-10',
    'UTC-9',
    'UTC-8',
    'UTC-7',
    'UTC-6',
    'UTC-5',
    'UTC-4',
    'UTC-3',
    'UTC-2',
    'UTC-1',
    'UTC+0',
    'UTC+1',
    'UTC+2',
    'UTC+3',
    'UTC+4',
    'UTC+5',
    'UTC+6',
    'UTC+7',
    'UTC+8',
    'UTC+9',
    'UTC+10',
    'UTC+11',
    'UTC+12',
    'UTC+13',
    'UTC+14',
];
var CHANNEX_COUNTRIES;
(function (CHANNEX_COUNTRIES) {
    CHANNEX_COUNTRIES["AF"] = "AF";
    CHANNEX_COUNTRIES["AX"] = "AX";
    CHANNEX_COUNTRIES["AL"] = "AL";
    CHANNEX_COUNTRIES["DZ"] = "DZ";
    CHANNEX_COUNTRIES["AS"] = "AS";
    CHANNEX_COUNTRIES["AD"] = "AD";
    CHANNEX_COUNTRIES["AO"] = "AO";
    CHANNEX_COUNTRIES["AI"] = "AI";
    CHANNEX_COUNTRIES["AQ"] = "AQ";
    CHANNEX_COUNTRIES["AG"] = "AG";
    CHANNEX_COUNTRIES["AR"] = "AR";
    CHANNEX_COUNTRIES["AM"] = "AM";
    CHANNEX_COUNTRIES["AW"] = "AW";
    CHANNEX_COUNTRIES["AU"] = "AU";
    CHANNEX_COUNTRIES["AT"] = "AT";
    CHANNEX_COUNTRIES["AZ"] = "AZ";
    CHANNEX_COUNTRIES["BS"] = "BS";
    CHANNEX_COUNTRIES["BH"] = "BH";
    CHANNEX_COUNTRIES["BD"] = "BD";
    CHANNEX_COUNTRIES["BB"] = "BB";
    CHANNEX_COUNTRIES["BY"] = "BY";
    CHANNEX_COUNTRIES["BE"] = "BE";
    CHANNEX_COUNTRIES["BZ"] = "BZ";
    CHANNEX_COUNTRIES["BJ"] = "BJ";
    CHANNEX_COUNTRIES["BM"] = "BM";
    CHANNEX_COUNTRIES["BT"] = "BT";
    CHANNEX_COUNTRIES["BO"] = "BO";
    CHANNEX_COUNTRIES["BQ"] = "BQ";
    CHANNEX_COUNTRIES["BA"] = "BA";
    CHANNEX_COUNTRIES["BW"] = "BW";
    CHANNEX_COUNTRIES["BV"] = "BV";
    CHANNEX_COUNTRIES["BR"] = "BR";
    CHANNEX_COUNTRIES["IO"] = "IO";
    CHANNEX_COUNTRIES["BN"] = "BN";
    CHANNEX_COUNTRIES["BG"] = "BG";
    CHANNEX_COUNTRIES["BF"] = "BF";
    CHANNEX_COUNTRIES["BI"] = "BI";
    CHANNEX_COUNTRIES["CV"] = "CV";
    CHANNEX_COUNTRIES["KH"] = "KH";
    CHANNEX_COUNTRIES["CM"] = "CM";
    CHANNEX_COUNTRIES["CA"] = "CA";
    CHANNEX_COUNTRIES["KY"] = "KY";
    CHANNEX_COUNTRIES["CF"] = "CF";
    CHANNEX_COUNTRIES["TD"] = "TD";
    CHANNEX_COUNTRIES["CL"] = "CL";
    CHANNEX_COUNTRIES["CN"] = "CN";
    CHANNEX_COUNTRIES["CX"] = "CX";
    CHANNEX_COUNTRIES["CC"] = "CC";
    CHANNEX_COUNTRIES["CO"] = "CO";
    CHANNEX_COUNTRIES["KM"] = "KM";
    CHANNEX_COUNTRIES["CG"] = "CG";
    CHANNEX_COUNTRIES["CD"] = "CD";
    CHANNEX_COUNTRIES["CK"] = "CK";
    CHANNEX_COUNTRIES["CR"] = "CR";
    CHANNEX_COUNTRIES["CI"] = "CI";
    CHANNEX_COUNTRIES["HR"] = "HR";
    CHANNEX_COUNTRIES["CU"] = "CU";
    CHANNEX_COUNTRIES["CW"] = "CW";
    CHANNEX_COUNTRIES["CY"] = "CY";
    CHANNEX_COUNTRIES["CZ"] = "CZ";
    CHANNEX_COUNTRIES["DK"] = "DK";
    CHANNEX_COUNTRIES["DJ"] = "DJ";
    CHANNEX_COUNTRIES["DM"] = "DM";
    CHANNEX_COUNTRIES["DO"] = "DO";
    CHANNEX_COUNTRIES["EC"] = "EC";
    CHANNEX_COUNTRIES["EG"] = "EG";
    CHANNEX_COUNTRIES["SV"] = "SV";
    CHANNEX_COUNTRIES["GQ"] = "GQ";
    CHANNEX_COUNTRIES["ER"] = "ER";
    CHANNEX_COUNTRIES["EE"] = "EE";
    CHANNEX_COUNTRIES["SZ"] = "SZ";
    CHANNEX_COUNTRIES["ET"] = "ET";
    CHANNEX_COUNTRIES["FK"] = "FK";
    CHANNEX_COUNTRIES["FO"] = "FO";
    CHANNEX_COUNTRIES["FJ"] = "FJ";
    CHANNEX_COUNTRIES["FI"] = "FI";
    CHANNEX_COUNTRIES["FR"] = "FR";
    CHANNEX_COUNTRIES["GF"] = "GF";
    CHANNEX_COUNTRIES["PF"] = "PF";
    CHANNEX_COUNTRIES["TF"] = "TF";
    CHANNEX_COUNTRIES["GA"] = "GA";
    CHANNEX_COUNTRIES["GM"] = "GM";
    CHANNEX_COUNTRIES["GE"] = "GE";
    CHANNEX_COUNTRIES["DE"] = "DE";
    CHANNEX_COUNTRIES["GH"] = "GH";
    CHANNEX_COUNTRIES["GI"] = "GI";
    CHANNEX_COUNTRIES["GR"] = "GR";
    CHANNEX_COUNTRIES["GL"] = "GL";
    CHANNEX_COUNTRIES["GD"] = "GD";
    CHANNEX_COUNTRIES["GP"] = "GP";
    CHANNEX_COUNTRIES["GU"] = "GU";
    CHANNEX_COUNTRIES["GT"] = "GT";
    CHANNEX_COUNTRIES["GG"] = "GG";
    CHANNEX_COUNTRIES["GN"] = "GN";
    CHANNEX_COUNTRIES["GW"] = "GW";
    CHANNEX_COUNTRIES["GY"] = "GY";
    CHANNEX_COUNTRIES["HT"] = "HT";
    CHANNEX_COUNTRIES["HM"] = "HM";
    CHANNEX_COUNTRIES["VA"] = "VA";
    CHANNEX_COUNTRIES["HN"] = "HN";
    CHANNEX_COUNTRIES["HK"] = "HK";
    CHANNEX_COUNTRIES["HU"] = "HU";
    CHANNEX_COUNTRIES["IS"] = "IS";
    CHANNEX_COUNTRIES["IN"] = "IN";
    CHANNEX_COUNTRIES["ID"] = "ID";
    CHANNEX_COUNTRIES["IR"] = "IR";
    CHANNEX_COUNTRIES["IQ"] = "IQ";
    CHANNEX_COUNTRIES["IE"] = "IE";
    CHANNEX_COUNTRIES["IM"] = "IM";
    CHANNEX_COUNTRIES["IL"] = "IL";
    CHANNEX_COUNTRIES["IT"] = "IT";
    CHANNEX_COUNTRIES["JM"] = "JM";
    CHANNEX_COUNTRIES["JP"] = "JP";
    CHANNEX_COUNTRIES["JE"] = "JE";
    CHANNEX_COUNTRIES["JO"] = "JO";
    CHANNEX_COUNTRIES["KZ"] = "KZ";
    CHANNEX_COUNTRIES["KE"] = "KE";
    CHANNEX_COUNTRIES["KI"] = "KI";
    CHANNEX_COUNTRIES["KP"] = "KP";
    CHANNEX_COUNTRIES["KR"] = "KR";
    CHANNEX_COUNTRIES["KW"] = "KW";
    CHANNEX_COUNTRIES["KG"] = "KG";
    CHANNEX_COUNTRIES["LA"] = "LA";
    CHANNEX_COUNTRIES["LV"] = "LV";
    CHANNEX_COUNTRIES["LB"] = "LB";
    CHANNEX_COUNTRIES["LS"] = "LS";
    CHANNEX_COUNTRIES["LR"] = "LR";
    CHANNEX_COUNTRIES["LY"] = "LY";
    CHANNEX_COUNTRIES["LI"] = "LI";
    CHANNEX_COUNTRIES["LT"] = "LT";
    CHANNEX_COUNTRIES["LU"] = "LU";
    CHANNEX_COUNTRIES["MO"] = "MO";
    CHANNEX_COUNTRIES["MG"] = "MG";
    CHANNEX_COUNTRIES["MW"] = "MW";
    CHANNEX_COUNTRIES["MY"] = "MY";
    CHANNEX_COUNTRIES["MV"] = "MV";
    CHANNEX_COUNTRIES["ML"] = "ML";
    CHANNEX_COUNTRIES["MT"] = "MT";
    CHANNEX_COUNTRIES["MH"] = "MH";
    CHANNEX_COUNTRIES["MQ"] = "MQ";
    CHANNEX_COUNTRIES["MR"] = "MR";
    CHANNEX_COUNTRIES["MU"] = "MU";
    CHANNEX_COUNTRIES["YT"] = "YT";
    CHANNEX_COUNTRIES["MX"] = "MX";
    CHANNEX_COUNTRIES["FM"] = "FM";
    CHANNEX_COUNTRIES["MD"] = "MD";
    CHANNEX_COUNTRIES["MC"] = "MC";
    CHANNEX_COUNTRIES["MN"] = "MN";
    CHANNEX_COUNTRIES["ME"] = "ME";
    CHANNEX_COUNTRIES["MS"] = "MS";
    CHANNEX_COUNTRIES["MA"] = "MA";
    CHANNEX_COUNTRIES["MZ"] = "MZ";
    CHANNEX_COUNTRIES["MM"] = "MM";
    CHANNEX_COUNTRIES["NA"] = "NA";
    CHANNEX_COUNTRIES["NR"] = "NR";
    CHANNEX_COUNTRIES["NP"] = "NP";
    CHANNEX_COUNTRIES["NL"] = "NL";
    CHANNEX_COUNTRIES["NC"] = "NC";
    CHANNEX_COUNTRIES["NZ"] = "NZ";
    CHANNEX_COUNTRIES["NI"] = "NI";
    CHANNEX_COUNTRIES["NE"] = "NE";
    CHANNEX_COUNTRIES["NG"] = "NG";
    CHANNEX_COUNTRIES["NU"] = "NU";
    CHANNEX_COUNTRIES["NF"] = "NF";
    CHANNEX_COUNTRIES["MK"] = "MK";
    CHANNEX_COUNTRIES["MP"] = "MP";
    CHANNEX_COUNTRIES["NO"] = "NO";
    CHANNEX_COUNTRIES["OM"] = "OM";
    CHANNEX_COUNTRIES["PK"] = "PK";
    CHANNEX_COUNTRIES["PW"] = "PW";
    CHANNEX_COUNTRIES["PS"] = "PS";
    CHANNEX_COUNTRIES["PA"] = "PA";
    CHANNEX_COUNTRIES["PG"] = "PG";
    CHANNEX_COUNTRIES["PY"] = "PY";
    CHANNEX_COUNTRIES["PE"] = "PE";
    CHANNEX_COUNTRIES["PH"] = "PH";
    CHANNEX_COUNTRIES["PN"] = "PN";
    CHANNEX_COUNTRIES["PL"] = "PL";
    CHANNEX_COUNTRIES["PT"] = "PT";
    CHANNEX_COUNTRIES["PR"] = "PR";
    CHANNEX_COUNTRIES["QA"] = "QA";
    CHANNEX_COUNTRIES["RE"] = "RE";
    CHANNEX_COUNTRIES["RO"] = "RO";
    CHANNEX_COUNTRIES["RU"] = "RU";
    CHANNEX_COUNTRIES["RW"] = "RW";
    CHANNEX_COUNTRIES["BL"] = "BL";
    CHANNEX_COUNTRIES["SH"] = "SH";
    CHANNEX_COUNTRIES["KN"] = "KN";
    CHANNEX_COUNTRIES["LC"] = "LC";
    CHANNEX_COUNTRIES["MF"] = "MF";
    CHANNEX_COUNTRIES["PM"] = "PM";
    CHANNEX_COUNTRIES["VC"] = "VC";
    CHANNEX_COUNTRIES["WS"] = "WS";
    CHANNEX_COUNTRIES["SM"] = "SM";
    CHANNEX_COUNTRIES["ST"] = "ST";
    CHANNEX_COUNTRIES["SA"] = "SA";
    CHANNEX_COUNTRIES["SN"] = "SN";
    CHANNEX_COUNTRIES["RS"] = "RS";
    CHANNEX_COUNTRIES["SC"] = "SC";
    CHANNEX_COUNTRIES["SL"] = "SL";
    CHANNEX_COUNTRIES["SG"] = "SG";
    CHANNEX_COUNTRIES["SX"] = "SX";
    CHANNEX_COUNTRIES["SK"] = "SK";
    CHANNEX_COUNTRIES["SI"] = "SI";
    CHANNEX_COUNTRIES["SB"] = "SB";
    CHANNEX_COUNTRIES["SO"] = "SO";
    CHANNEX_COUNTRIES["ZA"] = "ZA";
    CHANNEX_COUNTRIES["GS"] = "GS";
    CHANNEX_COUNTRIES["SS"] = "SS";
    CHANNEX_COUNTRIES["ES"] = "ES";
    CHANNEX_COUNTRIES["LK"] = "LK";
    CHANNEX_COUNTRIES["SD"] = "SD";
    CHANNEX_COUNTRIES["SR"] = "SR";
    CHANNEX_COUNTRIES["SJ"] = "SJ";
    CHANNEX_COUNTRIES["SE"] = "SE";
    CHANNEX_COUNTRIES["CH"] = "CH";
    CHANNEX_COUNTRIES["SY"] = "SY";
    CHANNEX_COUNTRIES["TW"] = "TW";
    CHANNEX_COUNTRIES["TJ"] = "TJ";
    CHANNEX_COUNTRIES["TZ"] = "TZ";
    CHANNEX_COUNTRIES["TH"] = "TH";
    CHANNEX_COUNTRIES["TL"] = "TL";
    CHANNEX_COUNTRIES["TG"] = "TG";
    CHANNEX_COUNTRIES["TK"] = "TK";
    CHANNEX_COUNTRIES["TO"] = "TO";
    CHANNEX_COUNTRIES["TT"] = "TT";
    CHANNEX_COUNTRIES["TN"] = "TN";
    CHANNEX_COUNTRIES["TR"] = "TR";
    CHANNEX_COUNTRIES["TM"] = "TM";
    CHANNEX_COUNTRIES["TC"] = "TC";
    CHANNEX_COUNTRIES["TV"] = "TV";
    CHANNEX_COUNTRIES["UG"] = "UG";
    CHANNEX_COUNTRIES["UA"] = "UA";
    CHANNEX_COUNTRIES["AE"] = "AE";
    CHANNEX_COUNTRIES["GB"] = "GB";
    CHANNEX_COUNTRIES["US"] = "US";
    CHANNEX_COUNTRIES["UM"] = "UM";
    CHANNEX_COUNTRIES["UY"] = "UY";
    CHANNEX_COUNTRIES["UZ"] = "UZ";
    CHANNEX_COUNTRIES["VU"] = "VU";
    CHANNEX_COUNTRIES["VE"] = "VE";
    CHANNEX_COUNTRIES["VN"] = "VN";
    CHANNEX_COUNTRIES["VG"] = "VG";
    CHANNEX_COUNTRIES["VI"] = "VI";
    CHANNEX_COUNTRIES["WF"] = "WF";
    CHANNEX_COUNTRIES["EH"] = "EH";
    CHANNEX_COUNTRIES["YE"] = "YE";
    CHANNEX_COUNTRIES["ZM"] = "ZM";
    CHANNEX_COUNTRIES["ZW"] = "ZW";
})(CHANNEX_COUNTRIES = exports.CHANNEX_COUNTRIES || (exports.CHANNEX_COUNTRIES = {}));
exports.CHANNEX_COUNTRIES_VALUES = [
    'AF',
    'AX',
    'AL',
    'DZ',
    'AS',
    'AD',
    'AO',
    'AI',
    'AQ',
    'AG',
    'AR',
    'AM',
    'AW',
    'AU',
    'AT',
    'AZ',
    'BS',
    'BH',
    'BD',
    'BB',
    'BY',
    'BE',
    'BZ',
    'BJ',
    'BM',
    'BT',
    'BO',
    'BQ',
    'BA',
    'BW',
    'BV',
    'BR',
    'IO',
    'BN',
    'BG',
    'BF',
    'BI',
    'CV',
    'KH',
    'CM',
    'CA',
    'KY',
    'CF',
    'TD',
    'CL',
    'CN',
    'CX',
    'CC',
    'CO',
    'KM',
    'CG',
    'CD',
    'CK',
    'CR',
    'CI',
    'HR',
    'CU',
    'CW',
    'CY',
    'CZ',
    'DK',
    'DJ',
    'DM',
    'DO',
    'EC',
    'EG',
    'SV',
    'GQ',
    'ER',
    'EE',
    'SZ',
    'ET',
    'FK',
    'FO',
    'FJ',
    'FI',
    'FR',
    'GF',
    'PF',
    'TF',
    'GA',
    'GM',
    'GE',
    'DE',
    'GH',
    'GI',
    'GR',
    'GL',
    'GD',
    'GP',
    'GU',
    'GT',
    'GG',
    'GN',
    'GW',
    'GY',
    'HT',
    'HM',
    'VA',
    'HN',
    'HK',
    'HU',
    'IS',
    'IN',
    'ID',
    'IR',
    'IQ',
    'IE',
    'IM',
    'IL',
    'IT',
    'JM',
    'JP',
    'JE',
    'JO',
    'KZ',
    'KE',
    'KI',
    'KP',
    'KR',
    'KW',
    'KG',
    'LA',
    'LV',
    'LB',
    'LS',
    'LR',
    'LY',
    'LI',
    'LT',
    'LU',
    'MO',
    'MG',
    'MW',
    'MY',
    'MV',
    'ML',
    'MT',
    'MH',
    'MQ',
    'MR',
    'MU',
    'YT',
    'MX',
    'FM',
    'MD',
    'MC',
    'MN',
    'ME',
    'MS',
    'MA',
    'MZ',
    'MM',
    'NA',
    'NR',
    'NP',
    'NL',
    'NC',
    'NZ',
    'NI',
    'NE',
    'NG',
    'NU',
    'NF',
    'MK',
    'MP',
    'NO',
    'OM',
    'PK',
    'PW',
    'PS',
    'PA',
    'PG',
    'PY',
    'PE',
    'PH',
    'PN',
    'PL',
    'PT',
    'PR',
    'QA',
    'RE',
    'RO',
    'RU',
    'RW',
    'BL',
    'SH',
    'KN',
    'LC',
    'MF',
    'PM',
    'VC',
    'WS',
    'SM',
    'ST',
    'SA',
    'SN',
    'RS',
    'SC',
    'SL',
    'SG',
    'SX',
    'SK',
    'SI',
    'SB',
    'SO',
    'ZA',
    'GS',
    'SS',
    'ES',
    'LK',
    'SD',
    'SR',
    'SJ',
    'SE',
    'CH',
    'SY',
    'TW',
    'TJ',
    'TZ',
    'TH',
    'TL',
    'TG',
    'TK',
    'TO',
    'TT',
    'TN',
    'TR',
    'TM',
    'TC',
    'TV',
    'UG',
    'UA',
    'AE',
    'GB',
    'US',
    'UM',
    'UY',
    'UZ',
    'VU',
    'VE',
    'VN',
    'VG',
    'VI',
    'WF',
    'EH',
    'YE',
    'ZM',
    'ZW',
];
exports.CHANNEX_CODES = {
    AT: 'AA Travel',
    ABB: 'Airbnb',
    ABR: 'Abreu Online',
    ACO: 'Acomodeo',
    AET: 'American Express Travel (Expedia)',
    AGO: 'Agoda',
    AGU: 'Accommodation Guru',
    AGY: 'Argenway',
    AHC: 'Amex The Hotel Collection (Expedia)',
    AHR: 'Amex FINE HOTELS AND RESORTS (Expedia)',
    ALO: 'Allocate',
    ALT: 'Alturabeds',
    AMD: 'AMADEUS',
    ANA: 'Andalucia Autentica',
    ANZ: 'ANZCRO',
    AOS: 'Asian Overland Services',
    AOT: 'AOT Sunlover',
    APL: 'Atrapalo',
    APT: 'Apartool',
    ARC: 'HotelCompany/Alpharooms',
    ARO: 'AroSuite',
    ATE: 'ATEL HOTELS',
    ATG: 'AIC Travel Group',
    AUR: 'Aura.Travel',
    AVV: 'Avvio',
    BAH: 'British Airways Holidays',
    BAR: 'Barcelo Viajes',
    BBN: 'BookingButton',
    BBP: 'BookingButton Plus',
    BBS: 'BookingButton Sapphire',
    BCC: 'Bookerclub.com',
    BDC: 'Booking.com',
    BET: 'Bonotel Exclusive Travel',
    BFT: 'Buffalo Tours',
    BHG: 'Bali Hotel Guide',
    BHO: 'Best Hotel Online',
    BIC: 'Bookit.com',
    BID: 'Bidroom',
    BIW: 'Book It With',
    BKC: 'BookingCore',
    BKE: 'Book Easy',
    BKS: 'Bookassist',
    BKT: 'Bookit.co.nz',
    BLK: 'Bookings.lk',
    BOK: 'BookVisit | Citybreak | Nozio',
    BON: 'Bookonlinenow',
    BRD: 'BridgeStreet',
    BST: 'BestDay Travel',
    BTD: 'Book Today',
    BTH: 'Booking2Hotels',
    BTP: 'Book That Place',
    BUD: 'budgetplaces.com',
    BWE: 'bedswithease',
    BWS: 'Best Western CRSConnect',
    BWZ: 'BookingWhizz',
    CAE: 'Caesar Data',
    CBS: 'CBS Travel Asia',
    CCK: 'CHECK24',
    CCT: 'BookingButton Cradle Coast Tourism',
    CDE: 'Connected Destination',
    CDT: 'Condor Travel',
    CGO: 'Cangooroo',
    CHC: 'Chic Retreats',
    CHM: 'Charming Italy',
    CHO: 'Choice CRS',
    CHT: 'CheapTickets (Expedia)',
    CIS: 'Cisalpina Tours',
    CLD: 'CloudHotelier',
    CNS: 'CanadaStays',
    CNT: 'CNTravel',
    CSV: 'Clearing Station (Vioma)',
    CTG: 'CNBooking.net',
    CTP: 'Ctrip',
    CWT: 'RoomIt by CWT',
    CYO: 'Calypso',
    CZB: 'Cityzenbooking',
    DBH: 'DayBreakHotels',
    DDC: 'Despegar',
    DIC: 'Discover Australia Contract',
    DID: 'Dida Travel Technology',
    DIP: 'Discover Australia Package',
    DIS: 'Discover Australia',
    DJO: 'Djoca Travel',
    DOW: 'Destinations of the World',
    DRI: 'Darmawisata Indonesia',
    DRM: 'Dorms.com',
    DRS: 'DIRS21',
    DSC: 'Destination.cool',
    DST: 'Destinia S.L.',
    DWH: 'DirectWithHotels',
    EAN: 'Expedia Affiliate Network (Expedia)',
    EBK: 'EasyBookings',
    EBS: 'ebookers (Expedia)',
    EBW: 'Easybooking by Webconnection',
    ECL: 'EC Travel',
    ECT: 'ECCO Tours',
    EDH: 'eDream Hotels',
    EDR: 'ODIGEO Connect',
    EET: 'Egypt Express Travel',
    EGD: 'Engrande/BudgetPlaces',
    EGN: 'Egencia (Expedia)',
    ELH: 'Exclusively Hotels (Total Stay)',
    ELO: 'eLong',
    EMA: 'BookingEye (eMarketingEye)',
    ENT: 'My Bookings / Entertainment',
    ESQ: 'Esquiades',
    ETB: 'EasyToBook',
    ETL: 'EasyTravel',
    ETO: 'eTourism',
    ETS: 'Etstur',
    EUP: 'Europlayas NEW',
    EVG: 'Evasion Voyage',
    EVO: 'EvoSuite',
    EXH: 'Excite Holidays',
    EXP: 'Expedia',
    EZT: 'eztravel',
    FBK: 'Fastbooking',
    FCH: 'fincahotels.com',
    FER: 'feratel Deskline',
    FHO: 'Fusion Holidays',
    FIJ: 'Fiji Airways Holidays (Trisept Solutions)',
    FLG: 'Fliggy',
    FPH: 'FastPayHotels',
    FSH: 'Fishing.cool',
    GAM: 'Getaroom.com',
    GBB: 'Goibibo',
    GBG: 'Garbage',
    GBR: 'grabrooms',
    GCB: 'Golden Chain Australia',
    GCC: 'GuestCentric Systems',
    GCR: 'GuestCentric Rewards',
    GCS: 'GuestCentric Channels',
    GDT: 'GoldenTour/Koedia',
    GEN: 'GDS by SiteMinder',
    GHE: 'GHE (Grand Hotel Excelsior)',
    GHS: 'GoHostels.com',
    GIC: 'Guest Incoming',
    GIM: 'GIMH S.A',
    GLK: 'Guestlink',
    GLL: 'GALILEO',
    GMO: 'Gomio',
    GMT: 'GOMMT',
    GNA: 'GNA Hotel Solutions',
    GNC: 'Grand National Concierge',
    GOA: 'Go2Africa',
    GOT: 'Grupo Opentours',
    GOW: 'Gowaii',
    GQO: 'GoQuo',
    GTA: 'GTA-Travel',
    HAB: 'Habicus Group (SilverDoor)',
    HAN: 'Hana Tour',
    HAO: 'Haoqiao',
    HBD: 'Hotelbeds',
    HBN: 'HBN Online',
    HBZ: 'Hotel Bonanza',
    HCC: 'Hardin County Conservation',
    HCL: 'HotelsClick',
    HCO: 'HotelsCombined',
    HDT: 'Hotel Direct',
    HEX: 'HotelExchange',
    HGO: 'Hutchgo',
    HIH: 'HiHostels',
    HIP: 'HipInn.com',
    HIS: 'HotelsInOne',
    HJZ: 'Hoojoozat',
    HKC: 'Hong Kong Convergent',
    HLB: 'HalalBooking',
    HLP: 'HotelsPro',
    HLS: 'Hoteliers.com',
    HNL: 'Hotels.nl',
    HNS: 'HotelNetSolutions',
    HNT: 'Realtime Travel Solutions',
    HOO: 'HotelOnline',
    HOS: 'HotelSpecials.nl',
    HPO: 'HotelPro IBE',
    HQK: 'HotelQuickly',
    HRA: 'H-Résa (MisterFly)',
    HRE: 'HReservations (BookitNow)',
    HRS: 'Hrs.com',
    HRT: 'Hero Travel',
    HSC: 'HostelsClub',
    HSP: 'HotelShopuk',
    HST: 'HS Travel',
    HSU: 'HotelShopuk - NEW (to replace the above soon)',
    HTC: 'HostelCulture',
    HTD: 'hotelthailland',
    HTI: 'HTI/eRes',
    HTL: 'Hotels.com (Expedia)',
    HTM: 'Hotelerum',
    HTN: 'HotelTonight',
    HTP: 'Hoterip',
    HTR: 'HotelTravel',
    HTS: 'HotelTools',
    HTT: 'Hotetec',
    HTV: 'Hotels.tv',
    HUA: 'Hua Min Tourism Reservation',
    HUN: 'Hunting.cool',
    HUS: 'Hotusa',
    HUT: 'Hutchgo.com',
    HWL: 'Hostel World',
    HWR: 'Hotwire (Expedia)',
    HYM: 'HotelPartner YM',
    IBC: 'IBC Hotels',
    IBK: 'GHS iBooking',
    ICI: 'iCastelli',
    IDO: 'Idiso',
    IES: 'i-escape',
    IHL: 'iHotelier',
    IHW: 'iHotelier PMSConnect',
    IMP: 'ImperaTours',
    INF: 'Infinite Hotel',
    INS: 'Instant Bookings (e-Travel Marketing)',
    INZ: 'Innstant (Zenith)',
    IOS: 'In1Solutions',
    ITL: 'Inovtravel',
    ITP: 'Inntopia',
    JAC: 'JacTravel',
    JET: 'Jetstar/Hooroo/Qantas',
    JMB: 'Jumbo Tours',
    JMI: 'Jumia Travel',
    JTB: 'JTB Hawaii',
    JTG: 'JTB Group',
    JTH: 'Jet2holidays',
    KRL: 'KiwiRail',
    KRZ: 'Kurzurlaub',
    KTL: 'Keytel',
    LDO: 'Lido',
    LMA: 'Lastminute.au (Expedia)',
    LNA: 'Lusanova',
    LOH: 'Lots Of Hotels',
    LOV: 'loveholidays',
    LRM: 'LateRooms/AsiaRooms',
    LRW: 'LateRooms',
    LSC: 'LeisureCom',
    LUX: 'LUXOS Select',
    LVN: 'LivnTravel',
    LXE: 'Luxury Escapes',
    LXN: 'Luxe Nomad',
    MAL: 'misteraladin.com',
    MAX: 'MaxEngine',
    MCP: 'EziBed/Mitchell Corp',
    MCW: 'Mitchell Corp Wholesale',
    MDR: 'Macdonald Resorts',
    MGC: 'MagicStay',
    MGH: 'MG Holiday',
    MGK: 'MG Bedbank',
    MGO: 'Migoa',
    MHB: 'MyHotelBreak',
    MJT: 'MrJet (Expedia)',
    MKT: 'Miki Travel',
    MMS: 'Mr and Mrs Smith',
    MPG: 'Meeting Point Global',
    MRI: 'Mirai',
    MRS: 'Myeres.com',
    MRZ: 'BookingButton MyRez',
    MSL: 'Marsol',
    MTC: 'MTC Group SA',
    MYX: 'Xcaliber',
    NAM: 'NamuTravel',
    NAY: 'NetAffinity',
    NBE: 'NewBook Express',
    NBK: 'NeoBookings',
    NEC: 'Neckermann (Expedia)',
    NIN: 'NeedItNow',
    NIV: 'Niu Viatge',
    NOM: 'Nomads and Base',
    NON: 'Not 1 Night',
    NTN: 'NT Incoming',
    NTT: 'Nites Travel',
    NXT: 'Nextel.travel',
    OBK: 'Rusticae',
    OHR: '1HotelRez',
    OLV: 'Olympia Viaggi',
    OME: 'Omega Hotels',
    ONE: 'OneNight',
    OPL: 'Off Peak Luxury',
    ORZ: 'Orbitz (Expedia)',
    OTB: 'On The Beach',
    OTS: 'Open Travel Service',
    OTZ: 'otelz.com',
    OVK: 'Ostrovok',
    OZA: 'OzAccom',
    PBB: 'Pacific BedBank',
    PCH: 'Priceline Hong Kong',
    PCL: 'Priceline.com',
    PGI: 'PegiPegi',
    PMR: 'Portimar',
    PPN: 'Pan Pacific Travel',
    PRF: 'Profitroom',
    PSC: 'Emviagem',
    PTA: 'Prestigia',
    PTC: 'PTC Express Travel',
    PTH: 'Paraty Hotels',
    PTL: 'PriceTravel',
    PYJ: 'PetsPyjamas',
    QBD: 'Flight Centre Travel Group',
    QRS: 'Quantum Reservations',
    RAK: 'Rakuten',
    RAL: 'ResortsandLodges.com',
    RAT: 'Openhotelier (ex. RoomAllot)',
    RCK: 'ResClick',
    RCL: 'Reconline',
    RFA: 'Roamfree',
    RGL: 'Regal',
    RKR: 'RajaKamar',
    RLG: 'ResLogic',
    RML: 'Roomlia',
    ROI: 'Roiback',
    ROM: 'Roomex',
    RPO: 'Rapibo',
    RSD: 'Reserve Direct',
    RST: 'Resortime',
    RSV: 'Rezserve',
    RTD: 'Room-Trade',
    RTL: 'Restel',
    RTS: 'Kognitiv',
    RVG: 'RezViewNG',
    RVP: 'GuestLeader',
    RWD: 'Rewards Corp',
    RXM: 'roomsXML.com',
    RYR: 'Ryanair Rooms',
    RZL: 'RezLive.com',
    SAH: 'South African Hotels',
    SAN: 'Safarinow.com',
    SAW: 'Serviced Apartments Worldwide',
    SCO: 'ScottDunn',
    SDB: 'SpeedyBooker.com',
    SEC: 'Secretplaces',
    SER: 'Serhs Tourism',
    SET: 'Setours',
    SFH: 'Surfholidays.com',
    SHR: 'Stash Hotel Rewards',
    SIT: 'Sidetours',
    SMB: 'Sembo',
    SMP: 'Simple Booking',
    SNH: 'SilverNeedle Hotels',
    SOL: 'Solferias',
    SPB: 'SuperBreak',
    SPD: 'Splendia',
    SPI: 'Spies (Expedia)',
    SPK: 'SuperBreak (New)',
    SST: 'Sun Series Travel',
    STA: 'Stay247',
    STL: 'Southall Travel',
    STS: 'Staylists',
    STV: 'STA Travel',
    STW: 'Special Tours Wholesalers',
    STY: 'Stay Today',
    SUN: 'SunHotels',
    SWE: 'Sawadee',
    SYX: 'Synxis',
    TAF: 'Thompsons Africa',
    TAN: 'TA Network',
    TAU: 'TOMAS Travel - Austria',
    TBE: 'TOMAS Travel - Berlin',
    TBH: 'TabletHotels',
    TBK: 'Travelbook.ph',
    TBL: 'TravelBullz (new)',
    TBO: 'TBOHolidays',
    TBZ: 'TravelBullz',
    TCO: 'Tourico',
    TDZ: 'Tour10',
    THN: 'The Hotel Network',
    THO: 'The Hotel Network (new)',
    TIB: 'TripConnect Instant Booking',
    TIK: 'Tikitour',
    TJG: 'Tjareborg (Expedia)',
    TKH: 'ThinkHotels',
    TKT: 'Tiket.com',
    TLE: 'Tumlare',
    TLO: 'Travelio.com',
    TMS: 'TOMAS Travel',
    TNU: 'Tuniu',
    TOA: 'Trend OperaDora',
    TOP: 'Shanghai Toptown',
    TPC: 'Trepic',
    TPL: 'Tourplan',
    TRA: 'Tripadvisor',
    TRB: 'TravelBird',
    TRC: 'Traveliko.com',
    TRG: 'Lastminute.com',
    TRK: 'Traveloka',
    TRL: 'Travelanium',
    TRN: 'Travelsens',
    TRP: 'dnata',
    TRS: 'TARS',
    TRV: 'Travelocity (Expedia)',
    TST: 'TravelStay',
    TSW: 'TOMAS Travel - Switzerland',
    TTC: 'The Travel Company LTD',
    TTH: 'TOMAS Travel - Thuringia',
    TTP: 'Travel Tripper',
    TTT: 'Tradewinds Tours & Travel',
    TTV: 'Trav Travel',
    TUN: 'Concorde - BookingEngine',
    TUR: 'Turu',
    TVC: 'Travco Corporation',
    TVS: 'TravelStay Network Services',
    TVT: 'Traveltool',
    TVY: 'Trust Voyager',
    TXA: 'Tourism Exchange Australia',
    UNR: 'Unister',
    VAC: 'Vacatia',
    VCS: 'VacayHome Connect',
    VET: 'Veturis Travel',
    VII: 'Viajes Interrias',
    VIN: 'Ving (Expedia)',
    VJU: 'Viajes Urbis',
    VOL: 'Viajes Olympia',
    VOO: 'Voordeeluitjes',
    VRC: 'VeryChic',
    TUJ: 'Tujia',
    WAK: 'Waka',
    WBE: 'WorldBlue',
    WBK: 'Wubook',
    WBR: 'WebRooms (Welman)',
    WDC: 'Wide Discovery',
    WHL: 'WHL Alba Travel',
    WIC: 'Welcome Incoming',
    WKD: 'Weekendesk',
    WKL: 'WeKnowLondon',
    WNP: 'Wanup',
    WOT: 'Wotif (Expedia)',
    WST: 'Website Travel',
    WTA: 'Wel-Travel Australia',
    WTB: 'Witbooking',
    XAT: 'Leisure Connector (X-Adapt)',
    XNI: 'Xenia International',
    YAU: 'YHA Australia',
    YNZ: 'YHA New Zealand',
    ZNU: 'Zanadu',
    ZOO: 'Travelzoo',
    ZUM: 'Zumata'
};
exports.CHANNEX_INTEGRATIONS_LIST = [
    {
        title: 'The Booking Factory',
        categories: ['PMS']
    },
    {
        title: 'Reservation Key',
        categories: ['PMS']
    },
    {
        title: 'Passepartout',
        categories: ['PMS']
    },
    {
        title: 'Prestige',
        categories: ['PMS']
    },
    {
        title: 'Hotelier 101',
        categories: ['PMS']
    },
    {
        title: 'Adobe Booking',
        categories: ['PMS']
    },
    {
        title: 'Apartbook',
        categories: ['PMS']
    },
    {
        title: 'Ermes Hotels',
        categories: ['PMS']
    },
    {
        title: 'Frontdesk Express',
        categories: ['PMS']
    },
    {
        title: 'Grup Hotel',
        categories: ['PMS']
    },
    {
        title: 'Resmaster',
        categories: ['PMS']
    },
    {
        title: 'My Rent',
        categories: ['PMS']
    },
    {
        title: 'Zavia',
        categories: ['PMS']
    },
    {
        title: 'Book And Link',
        categories: ['PMS', 'CM']
    },
    {
        title: 'Coral',
        categories: ['IBE', 'CM']
    },
    {
        title: 'Sync Rentals',
        categories: ['PMS']
    },
    {
        title: 'Ayrton',
        categories: ['PMS']
    },
    {
        title: 'Airbnb',
        categories: ['OTA']
    },
    {
        title: 'Booking.com',
        categories: ['OTA']
    },
    {
        title: 'Expedia',
        categories: ['OTA']
    },
    {
        title: 'Google Hotel Ads',
        categories: ['OTA', 'META']
    },
    {
        title: 'Local Ota',
        categories: ['OTA']
    },
    {
        title: 'Room Price Genie',
        categories: ['RM']
    },
    {
        title: 'Pricepoint',
        categories: ['RM']
    },
    {
        title: 'Lybra Tech',
        categories: ['RM']
    },
    {
        title: 'Hotel Link Solutions',
        categories: ['CM']
    },
    {
        title: 'Wubook',
        categories: ['CM']
    },
    {
        title: 'Resavenue',
        categories: ['CM', 'IBE']
    },
    {
        title: 'CMReservas',
        categories: ['CM', 'IBE']
    },
    {
        title: 'Room Cloud',
        categories: ['CM', 'IBE']
    },
    {
        title: 'HyperGuest',
        categories: ['ALT']
    },
];
//# sourceMappingURL=channex.constants.js.map